import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef, Suspense } from "react";
import { cn } from "../lib/utils";
import { PreviewProvider } from "../context/PreviewContext";
const cardComponentsMap = {
    hero1: React.lazy(() => import("./hero/Hero1")),
    hero2: React.lazy(() => import("./hero/Hero2")),
    hero3: React.lazy(() => import("./hero/Hero3")),
    hero4: React.lazy(() => import("./hero/Hero4")),
    hero5: React.lazy(() => import("./hero/Hero5")),
    link1: React.lazy(() => import("./link/Link1")),
    link2: React.lazy(() => import("./link/Link2")),
    link3: React.lazy(() => import("./link/Link3")),
    link4: React.lazy(() => import("./link/Link4")),
    link5: React.lazy(() => import("./link/Link5")),
    link6: React.lazy(() => import("./link/Link6")),
    image1: React.lazy(() => import("./image/Image1")),
    image2: React.lazy(() => import("./image/Image2")),
    image3: React.lazy(() => import("./image/Image3")),
    image4: React.lazy(() => import("./image/Image4")),
    image5: React.lazy(() => import("./image/Image5")),
    feature1: React.lazy(() => import("./feature/Feature1")),
    feature2: React.lazy(() => import("./feature/Feature2")),
    text1: React.lazy(() => import("./text/Text1")),
    faq1: React.lazy(() => import("./faq/Faq1")),
    faq2: React.lazy(() => import("./faq/Faq2")),
    whatsapp1: React.lazy(() => import("./whatsapp/Whatsapp1")),
    whatsapp2: React.lazy(() => import("./whatsapp/Whatsapp2")),
    tipping1: React.lazy(() => import("./tipping/Tipping1")),
    tipping2: React.lazy(() => import("./tipping/Tipping2")),
    footer1: React.lazy(() => import("./footer/Footer1")),
};
const Card = forwardRef(({ type, isPreview, className, ...props }, ref) => {
    const CardComponent = cardComponentsMap[type];
    if (!CardComponent) {
        return _jsx("div", { ref: ref });
    }
    return (_jsx("div", { className: cn("flex w-full", isPreview && "h-full", className), ref: ref, children: _jsx(PreviewProvider, { value: !!isPreview, children: _jsx(Suspense, { fallback: null, children: _jsx(CardComponent, { ...props }) }) }) }));
});
Card.displayName = "Card";
export default Card;
